export default __webpack_public_path__ + "static/media/yd-appreciation.a422a48c.png";